import React, { useState, useEffect } from "react";
import { isArray } from "lodash";
import MuiAlert from "@material-ui/lab/Alert";
import MUISnackbar from "@material-ui/core/Snackbar";
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser();

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Toastmessage = ({ message, type, open, close, autoHideDuration = 4000 }) => {
  const [openInternal, setOpen] = useState(false);

  const handleClose = (_event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    close();
  };

  useEffect(() => setOpen(open), [open]);

  return (
    <>
      {type && (
        <MUISnackbar
          open={openInternal}
          autoHideDuration={autoHideDuration}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity={type}>
            {/* {htmlToReactParser.parse(message)} */}
            {(isArray(message) && message.map((item) => <p>{item}</p>)) || (
              <p>{message}</p>
            )}
          </Alert>
        </MUISnackbar>
      )}
    </>
  );
};

export default Toastmessage;
